/**
 * ConverterHero Component
 *
 * Hero section for the converter page.
 */

import { memo } from 'react';
import { RefreshCw, Zap, Shield } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

export const ConverterHero = memo(function ConverterHero() {
  const { t } = useTranslation();

  return (
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-primary-500 to-purple-600 rounded-2xl mb-4 shadow-lg">
        <RefreshCw className="w-8 h-8 text-white" />
      </div>
      <h1 className="text-2xl sm:text-3xl font-bold text-secondary-900 dark:text-white">
        {t('converter.title', { defaultValue: 'Media Converter' })}
      </h1>
      <p className="mt-2 text-secondary-600 dark:text-secondary-400 max-w-xl mx-auto">
        {t('converter.description', {
          defaultValue: 'Convert audio and video files between 50+ formats',
        })}
      </p>

      {/* Feature badges */}
      <div className="flex flex-wrap justify-center gap-3 mt-4">
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-400 text-sm rounded-full">
          <Zap className="w-4 h-4" />
          {t('converter.features.fast', { defaultValue: 'Fast Conversion' })}
        </span>
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400 text-sm rounded-full">
          <Shield className="w-4 h-4" />
          {t('converter.features.quality', { defaultValue: 'High Quality' })}
        </span>
      </div>
    </div>
  );
});

export default ConverterHero;
